<div class="container flex-column" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end mt-2">
    <img src="assets/Logo-eSPAJK.jpg" width="160" height="auto">
  </div>
  <div class="riplay-title">
    <h2 class="text-center mt-5 color-blue"><b>ELLISE Sales Dashboard</b></h2>
  </div>
</div>

<div class="container mt-5 pt-4 form-header form-content bg-white">
  <div class="bg-white form-content pb-3 align-content-center mb-4">
    <div class="px-2">
      <div class="d-flex justify-content-between flex-row">
        <p (click)="back()" class="cursor-pointer"><i class="bi bi-arrow-left"></i> Kembali</p>
      </div>

      <div class="bg-white p-2 form-content">
        <p class="title-input m-0 color-gray">Nama Lengkap</p>
        <h4 class="title-input mt-0 color-gray">{{ summary.fullName }}</h4>

        <p class="title-input m-0 color-gray">Nomor Aplikasi</p>
        <h4 class="title-input mt-0 color-gray">{{ summary.applicationNo }} </h4>
      </div>

      <form [formGroup]="nameAppNoForm" (ngSubmit)="continue()" #form="ngForm">

        <div class="bg-white p-2 form-content">
          <div class="d-flex flex-column mb-2"
               [ngClass]="{'text-danger' : (nameAppNoForm.controls['nama'].dirty || form.submitted) && !nameAppNoForm.controls['nama'].valid}">
            <p class="title-input m-0">Perbaikan Nama Lengkap</p>
            <div class="d-flex align-items-center">
              <input class="bottom-border flex-grow-1" type="text" formControlName="nama"
                     [readOnly]="isInputReadonly"
                     [ngClass]="{'text-danger' : (nameAppNoForm.controls['nama'].dirty || form.submitted) && !nameAppNoForm.controls['nama'].valid}">
            </div>
          </div>
        </div>

        <div class="bg-white p-2 form-content">
          <div class="d-flex flex-column mb-2"
               [ngClass]="{'text-danger' : (nameAppNoForm.controls['appNo'].dirty || form.submitted) && !nameAppNoForm.controls['appNo'].valid}">
            <p class="title-input m-0">Perbaikan Nomor Aplikasi</p>
            <div class="d-flex align-items-center">
              <input class="bottom-border flex-grow-1" type="text" formControlName="appNo" [maxlength]="20"
                     [readOnly]="isInputReadonly"
                     [ngClass]="{'text-danger' : (nameAppNoForm.controls['appNo'].dirty || form.submitted) && !nameAppNoForm.controls['appNo'].valid}">
            </div>
          </div>
        </div>

        <p class="description-input text-center">Perbaikan nama lengkap dan nomor aplikasi hanya bisa dilakukan maksimum 60 hari sejak tanggal pengajuan asuransi</p>

        <div class="d-flex flex-row justify-content-center flex-gap">
          <button class="rounded-3 btn-continue mt-3 py-3 flex-grow-1" type="submit">
            <span *ngIf="this.isLoading" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
            Ajukan Perbaikan
          </button>
        </div>
      </form>
    </div>
